import React from "react";
import { connect } from "react-redux";
import { postKeywordList } from "../Actions/KeywordManagementAPI";

class KeywordAdd extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      keyword: "",
      createdBy: "",
    }
    this.handleInputChange = this.handleInputChange.bind(this);
    this.SubmitData = this.SubmitData.bind(this);
  }

  handleInputChange(e) {
    this.setState({
      keyword: e.target.value
    });
  }

  SubmitData() {
    this.props.dispatch(postKeywordList(this.state));
    this.setState({
      keyword: ""
    });
    this.hideSidePanel();
  }

  hideSidePanel = () => {
  //  this.props.dispatch({ type: "ShowSidePan", data: false });
    this.props.history.push(`/Home/Management/Keyword`);
  };

  CancelSidePanel = () => {
    this.hideSidePanel();
  }

  render() {

    return (
      <div className="full-height">
        <div className="resource-list-auth-date row pt-3">
          <div className="col-lg-12">
            <div className="panel-box search-filter-box">
              {/* <button
                className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                onClick={() => this.hideSidePanel()}
              >
                &larr; Return
              </button> */}
              <div className="card MM-card-header mt-2 mb-0" style={{ backgroundColor: "white", border: "0px" }}>
                <div className="card-body">
                  <h5 className="card-title ml-2 mt-2" style={{ color: "092a51" }}>
                    Add Keyword
                  </h5>
                </div>
              </div>
              <div className="search-filter-box">
                <div className="row pb-1">
                  <div className="col-lg-6">
                    <label className="form-label">Keyword</label>
                    <br></br>
                    <input
                      className="form-control"
                      type="text"
                      name="keyword"
                      placeholder="Keyword"
                      value={this.state.keyword}
                      onChange={e => this.handleInputChange(e)}
                    ></input>
                  </div>
                  <div className="col-lg-6 pt-3">
                    <label></label><br></br>
                    <div className="search-btn-col" style={{ textAlign: "end" }}>
                      <button
                        className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                        type="submit"
                        onClick={() => this.SubmitData()}
                      >
                        {" "}Submit{" "}
                      </button>
                      <button
                        className="btn btn-light text-uppercase txtside-btn txtht-btn ml-3"
                        type="button"
                        onClick={() => this.CancelSidePanel()}
                      >
                        {" "}Cancel{" "}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

}
function mapStateToProps(state) {
  return {
  
  };
}
function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(KeywordAdd);
